import React, { useState } from 'react';
import { Accordion } from 'react-bootstrap';

export default function NameView({ onStart, hintText }) {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");

  return (
    <div className="container py-5" style={{ maxWidth: '700px' }}>

      {/* HINTTEXT vom Backend */}
      {hintText && (
        <div className="mb-4" dangerouslySetInnerHTML={{ __html: hintText }} />
      )}

     

      <div className="row mb-3">
        <div className="col-md-6">
          <label className="form-label">Dein Vorname</label>
          <input className="form-control" placeholder="z. B. Anna" value={firstName} onChange={e => setFirstName(e.target.value)} />
        </div>
        <div className="col-md-6">
          <label className="form-label">Dein Nachname</label>
          <input className="form-control" placeholder="z. B. Schulz" value={lastName} onChange={e => setLastName(e.target.value)} />
        </div>
      </div>

      <button className="btn btn-primary w-100 mb-4" onClick={() => onStart(firstName, lastName)}>
        Los geht’s!
      </button>

      <p className="text-muted small">
        <strong>Wichtiger Hinweis:</strong> Jede Person kann nur einmal am Fussball Diversity Quiz 2025 teilnehmen.
        Bei Mehrfachteilnahme wird nur die erste Teilnahme berücksichtigt.
      </p>

      <Accordion flush>
        <Accordion.Item eventKey="0">
          <Accordion.Header>🔒 Datenschutzhinweis anzeigen</Accordion.Header>
          <Accordion.Body>
            Die im Rahmen dieses Quiz erhobenen Daten (clubbbezogener Code und Name) werden ausschließlich für die Durchführung der Diversity Challenge verwendet und sicher gespeichert. Es werden keine personenbezogenen Daten veröffentlicht.<br /><br />

            Mit den Vereinsansprechpersonen werden lediglich:
            <ul>
              <li>die Anzahl der teilnehmenden Mitarbeitenden aus ihrer Organisation sowie</li>
              <li>die Namen der Personen aus ihrer Organisation, die mindestens 6 von 11 Fragen richtig beantwortet haben</li>
            </ul>
            geteilt. Die Daten werden ausschließlich zum Zweck der Teilnahme an einer lokalen Verlosung geteilt.
            Eine darüberhinausgehende Weitergabe oder Nutzung erfolgt nicht.
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
}
